import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.primary.lighter,
    borderRadius: 18,
    padding: theme.spacing(3),
  },
  tabs: {
    minHeight: theme.spacing(5),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      marginBottom: theme.spacing(5),
    },
  },
  indicator: {
    backgroundColor: theme.palette.primary.light,
  },
  tab: {
    whiteSpace: 'nowrap',
    minHeight: 36,
    minWidth: 0,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    textTransform: 'none',
    '&.Mui-selected': {
      color: theme.palette.primary.light,
    },
  },
  tabPanel: {
    overflowX: 'scroll',
    [theme.breakpoints.up('lg')]: {
      overflowX: 'visible',
    },
  },
}))

export default useStyles
